<template>
  <v-slide-y-transition>
    <v-card v-if="visible" class="download-notifications" elevation="2">
      <v-toolbar density="compact" flat>
        <v-toolbar-title>Downloads</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleVisibility">
          <v-icon>{{
            minimized ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon>
        </v-btn>
        <v-btn icon @click="hideNotifications">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list v-show="!minimized" density="compact">
        <v-list-item
          v-for="notification in notifications"
          :key="notification.id"
          :ref="(el) => setNotificationRef(el, index)"
        >
          <template v-slot:prepend>
            <v-icon v-if="notification.completed" color="#008000">
              mdi-check-circle
            </v-icon>
            <v-progress-circular
              v-else
              indeterminate
              size="20"
              color="primary"
              class="icon-margin"
            ></v-progress-circular>
          </template>
          <v-divider></v-divider>
          <v-list-item-title class="small-font">{{
            notification.key
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-slide-y-transition>
</template>

<script>
import { nextTick } from "vue";

export default {
  name: "DownloadNotifications",
  data() {
    return {
      visible: true,
      minimized: false,
      notificationRefs: {},
    };
  },
  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },
  watch: {
    notifications: {
      handler() {
        this.showNotifications();
        this.scrollToLatestNotification();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    hideNotifications() {
      this.visible = false;
    },
    showNotifications() {
      this.visible = true;
    },
    toggleVisibility() {
      this.minimized = !this.minimized;
    },
    setNotificationRef(el, index) {
      if (el) {
        this.notificationRefs[index] = el.$el || el;
      }
    },
    async scrollToLatestNotification() {
      await nextTick();
      const lastNotificationKey = Object.keys(this.notificationRefs).pop();
      const lastNotification = this.notificationRefs[lastNotificationKey];
      if (lastNotification && lastNotification.scrollIntoView) {
        lastNotification.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    },
  },
};
</script>

<style scoped>
.download-notifications {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
  max-height: 30vh;
  overflow-y: auto;
  z-index: 1000;
}

.small-font {
  font-size: 0.875rem; /* Smaller font size */
}
.icon-margin {
  margin-right: 36px; /* Add margin to the right of the icon */
}

.v-list {
  max-height: 20vh; /* Slightly smaller than the card's max height to account for other elements */
  overflow-y: auto; /* This makes just the list scrollable */
}
</style>
